import useForm from "../../../hooks/useForm";
import { CloseModal } from "../../../hooks/useModal";
import usePageState from "../../../hooks/usePageState";
import AppInputText from "../../../components/AppInputText/AppInputText";
import BaseDialog from "../../../components/BaseDialog";
import DialogFooter from "../../../components/DialogFooter";
import * as Yup from "yup";
import { returnOrderUseCase } from "../../../../applications/useCase/ApiUseCase/OrderApiUseCase";

interface ConfirmReturnOrderDialogProps {
  onClose: CloseModal;
  orderId: number;
}

function ConfirmReturnOrderDialog(props: ConfirmReturnOrderDialogProps) {
  const { onClose, orderId } = props;
  const { showClientError, showError, setLoading, isLoading, showSuccess } = usePageState();

  const formik = useForm<{ password: string }>({
    initialValues: {
      password: "",
    },
    validationSchema: Yup.object({
      password: Yup.string().required("Mật khẩu không được để trống"),
    }),
    onSubmit: async (values) => {
      const res = await returnOrderUseCase({
        orderId,
        password: values.password,
        setLoading,
        showError,
        showSuccess,
      });
      if (res) {
        onClose(true);
      }
    },
  });

  return (
    <BaseDialog
      title={"Nhập mật khẩu để xác nhận đơn hàng hoàn"}
      isLoading={isLoading}
      footer={
        <DialogFooter
          submitProps={{
            onClick: () => formik.checkErrorAndSubmit(showClientError),
          }}
          cancelProps={{
            onClick: () => onClose(),
          }}
        />
      }
    >
      <AppInputText
        currentValue={formik.values.password}
        onTextChange={(value) => {
          formik.updateFieldValue("password", value);
        }}
        additionProps={{
          className: "w-100",
          onCut: (e: React.ClipboardEvent<HTMLInputElement>) => {
            e.preventDefault();
          },
          onCopy: (e: React.ClipboardEvent<HTMLInputElement>) => {
            e.preventDefault();
          },
        }}
        textType={"PASSWORD"}
      />
    </BaseDialog>
  );
}
export default ConfirmReturnOrderDialog;
